import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/herramientas-para-retail")({
  beforeLoad: () => { throw redirect({ to: "/herramientas", statusCode: 301 }); },
});
